import { render, staticRenderFns } from "./SidebarLoyaltyProducts.vue?vue&type=template&id=25d1047b&scoped=true"
import script from "./SidebarLoyaltyProducts.vue?vue&type=script&lang=js"
export * from "./SidebarLoyaltyProducts.vue?vue&type=script&lang=js"
import style0 from "./SidebarLoyaltyProducts.vue?vue&type=style&index=0&id=25d1047b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d1047b",
  null
  
)

export default component.exports